import Nav from "./Nav";
import Footer from "./Footer";
import "./home.css";
import StandardExpressList from "../Components/ListpageExpress";
import { base64backendtoken } from "../HelperFx/datalinks.js";

const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;

const formatLogDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString();
};

const logUserName = (row) =>
  row.userName || row.UserName || row.User || row.user || "";

const logLoginAt = (row) =>
  row.loginAt || row.LoginAt || row.FirstLoginAt || row.createdAt || "";

const logLogoutAt = (row) => row.logoutAt || row.LogoutAt || "";

const UserLogs = () => {
  const columns = [
    {
      name: "User Name",
      selector: (row) => logUserName(row),
      sortable: true,
    },
    {
      name: "Login Status",
      selector: (row) =>
        row.loginStatus || row.LoginStatus ? "Logged in" : "Logged out",
      sortable: true,
    },
    {
      name: "Logged in At",
      selector: (row) => formatLogDate(logLoginAt(row)),
      sortable: true,
    },
    {
      name: "Logged Out At",
      selector: (row) => formatLogDate(logLogoutAt(row)),
      sortable: true,
    },
  ];

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main settings-full">
        <StandardExpressList
          apiUrl={`${REACT_EXPRESS}/logs`}
          token={base64backendtoken}
          columns={columns}
          searchKeys={["userName", "UserName", "User"]}
          pageCaption="User Logs"
          actionvisibility={false}
          redirectTo="UserManagement"
          infiniteScroll
        />
      </div>
      <Footer />
    </div>
  );
};

export default UserLogs;
